/**
 * Canonical home path per role — the single source of truth for "where does
 * this role land". Used by full-screen leaf pages (LogJob, JobDetail) as the
 * default return destination when no explicit `returnTo` was passed in
 * navigate state.
 *
 * Leaf-page exit policy: these pages are pushed onto history when opened and
 * MUST be left with `navigate(dest, { replace: true })` so the leaf entry is
 * swapped out of the stack — never left behind as a stale iOS swipe-back /
 * browser-back target. See CLAUDE.md "Leaf-page navigation".
 */
export function roleHomePath(role) {
  switch (role) {
    // RD-NAV-001: all four tenant roles live under the /app shell.
    case 'worker':
    case 'supervisor':
    case 'admin':
    case 'billing':
      return '/app/dashboard';
    default: return '/';
  }
}
